import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";

export default function CoreCustomTab({ tabs }) {
  const [selTab, setSelTab] = useState(tabs[0]?.head);

  const handleChange = (event, newValue) => {
    setSelTab(newValue);
  };

  return (
    <>
      <Tabs value={selTab} onChange={handleChange}>
        {tabs?.map((tab) => (
          <Tab key={tab.head} value={tab.head} label={tab.head} />
        ))}
      </Tabs>
      {tabs?.map((tab, ind) => (
        <Box key={tab.head + "-" + ind}>
          {tab.head === selTab ? tab.body : null}
        </Box>
      ))}
    </>
  );
}
